<div class="view">
  
  <h2>Notification Contacts</h2>

  <!-- <h5>Country</h5>

  <div class="inline-controls">
    <mat-form-field disabled>
      <mat-label>Country code</mat-label>
      <mat-select oneSelect [formControl]="countryCodeFC" appearance="fill" size="big" (valueChange)="onCountryCodeValueChange($event)">
        <mat-option  [value]="code" [title]="code" *ngFor="let code of countryCodes">
          {{code}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->

  <h5>Affected accounts</h5>

  <div class="inline-controls">

    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select oneSelect [formControl]="affAccFC" appearance="fill" size="big" (valueChange)="onAccountsSourceValueChange($event)">
        <mat-option value="none">Any</mat-option>
        <mat-option value="instrument">By instrument</mat-option>
        <mat-option value="shipments">By shipments</mat-option>
      </mat-select>
    </mat-form-field>
    <button *ngIf="affAccFC.value" one-icon-button-flat mat-flat-button matSuffix (click)="clearChildValue('affAccFC'); affAccFC.reset()">
      <mat-icon>clear</mat-icon>
    </button>

    <div *ngIf="showAccountsByIntrument && affAccFC.value === 'instrument'">
      <div *ngFor = "let insutrumentNumber of instrumentMaterials; let i = index">
      <mat-form-field appearance="fill" size="big" oneFormField>
        <mat-label>Instrument material number</mat-label>
        <input autofocus matInput [formControl]="insutrumentNumber.control" placeholder="Instrument material number" id="instruMatFC-{{i}}" (input)="onMaterialNoValueChange($event, i)" />
        <button *ngIf="insutrumentNumber.control.value" one-icon-button-flat mat-flat-button matSuffix (click)="insutrumentNumber.control.reset(); clearButton('instruMatFC-'+i)">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
      <button *ngIf="instrumentMaterialNumber && i === 0" one-icon-button-flat mat-flat-button matSuffix (click)="addInstrumentField()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#f00"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
      </button>
      <button *ngIf="instrumentMaterialNumber && i !== 0" one-icon-button-flat mat-flat-button matSuffix (click)="removeInstrumentField(i)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#EA3323"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </button>
      </div>
    </div>

    <div *ngIf="showAccountsByIntrument && affAccFC.value === 'instrument'">
      <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select oneSelect [formControl]="instrumentStatusFC" appearance="fill" size="big" (valueChange)="onInstrumentStatusChange($event)">
          <mat-option value="none">Any</mat-option>
          <mat-option value="installed">Installed</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="showAccountsByShipments && affAccFC.value === 'shipments'" class="inline-controls">
      <div *ngFor ="let regMaterialBatchNo of reagentMaterialBatchNumber; let i = index">
      <mat-form-field appearance="fill" size="big" oneFormField class ="mat-field">
        <mat-label>Reagent material number</mat-label>
        <input autofocus matInput [formControl]="regMaterialBatchNo.reagentMaterialNumber" placeholder="Reagent material number" id="reagentMatFC-{{i}}" (input)="onReagentMaterialNoBatchNoValueChange($event, i)" />
        <button *ngIf="regMaterialBatchNo.reagentMaterialNumber.value" one-icon-button-flat mat-flat-button matSuffix (click)="regMaterialBatchNo.reagentMaterialNumber.reset(); clearButton('reagentMatFC-'+i)">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" size="big" oneFormField>
        <mat-label>Batch number</mat-label>
        <input autofocus matInput [formControl]="regMaterialBatchNo.batchNumber" placeholder="Batch number" id="batchNumFC-{{i}}" (input)="onReagentMaterialNoBatchNoValueChange($event, i)" />
        <button *ngIf="regMaterialBatchNo.batchNumber.value" one-icon-button-flat mat-flat-button matSuffix (click)="regMaterialBatchNo.batchNumber.reset(); clearButton('batchNumFC-'+i)">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>

      <button  *ngIf="regMaterialBatchNo && i === 0"one-icon-button-flat mat-flat-button matSuffix (click)="addReagentBatchField()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#f00"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
      </button>
      <button *ngIf="regMaterialBatchNo && i !== 0" one-icon-button-flat mat-flat-button matSuffix (click)="removeReagentBatchField(i)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#EA3323"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      </button>
      </div>
      <mat-form-field oneFormField appearance="fill" size="big">
        <mat-icon matPrefix style="padding-right: 1rem;">date</mat-icon>
        <mat-label>Date from</mat-label>
        <input
          matInput
          [formControl]="datepickeFromFC"
          [matDatepicker]="pickerFrom"
          (focus)="pickerFrom.open()"
          data-test-id="basic-datepicker-component.input"
          (dateChange)="onDateFromValueChange($event)"
          id="datepickeFromFC"
          readonly
        />
      
        <button mat-icon-button one-icon-button matSuffix (click)="datepickeFromFC.reset(); clearButton('datepickeFromFC')">
          <mat-icon
            matSuffix
            data-test-id="basic-datepicker-component.clear-icon"
            >clear
          </mat-icon>
        </button>
        <mat-datepicker #pickerFrom></mat-datepicker>
      </mat-form-field>

      <mat-form-field oneFormField appearance="fill" size="big">
        <mat-icon matPrefix style="padding-right: 1rem;">date</mat-icon>
        <mat-label>Date to</mat-label>
        <input
          matInput
          [formControl]="datepickeToFC"
          [matDatepicker]="pickerTo"
          [matDatepickerFilter]="dateToFilter"
          (focus)="pickerTo.open()"
          data-test-id="basic-datepicker-component.input"
          (dateChange)="onDateToValueChange($event)"
          id="datepickeToFC"
          readonly
        />
      
        <button mat-icon-button one-icon-button matSuffix (click)="datepickeToFC.reset(); clearButton('datepickeToFC')">
          <mat-icon
            matSuffix
            data-test-id="basic-datepicker-component.clear-icon"
            >clear
          </mat-icon>
        </button>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>

        <mat-form-field>
          <mat-label>Partner Role</mat-label>
          <mat-select oneSelect [formControl]="shipPartnerRoleFC" multiple appearance="fill" size="big" (valueChange)="onShipmentPartnerRoleChange($event)">
            <mat-select-trigger>
               {{ selectedRolesDisplay() }}
            </mat-select-trigger>
            <mat-option value="all">All</mat-option>
            <mat-option value="ag">AG</mat-option>
            <mat-option value="re">RE</mat-option>
            <mat-option value="rg">RG</mat-option>
            <mat-option value="sp">SP</mat-option>
            <mat-option value="y1">Y1</mat-option>
            <mat-option value="y2">Y2</mat-option>
            <mat-option value="we">WE</mat-option>
          </mat-select>
        </mat-form-field>
        <button *ngIf="shipPartnerRoleFC.value" one-icon-button-flat mat-flat-button matSuffix (click)="clearSelectedValue(shipPartnerRoleFC)">
          <mat-icon>clear</mat-icon>
        </button>
      
    </div>
  </div>

  <h5>Contacts</h5>

  <div class="inline-controls">

    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select oneSelect [formControl]="contactFC" appearance="fill" size="big" (valueChange)="onContactsSourceValueChange($event)">
        <mat-option value="none">None</mat-option>
        <mat-option value="instrument">By instrument</mat-option>
        <mat-option value="safetyAndQuality">By contact attributes</mat-option>
      </mat-select>
    </mat-form-field>
    <button *ngIf="contactFC.value" one-icon-button-flat mat-flat-button matSuffix (click)="clearChildValue('contactFC'); contactFC.reset()">
      <mat-icon>clear</mat-icon>
    </button>

    <div *ngIf="((!showAccountsByIntrument && showContactsByInstrument) || affAccFC.value === null ) && contactFC.value === 'instrument'">
      <div *ngFor = "let insutrumentNumber of instrumentMaterials; let i = index">
        <mat-form-field appearance="fill" size="big" oneFormField>
          <mat-label>Instrument material number</mat-label>
          <input autofocus matInput [formControl]="insutrumentNumber.control" placeholder="Instrument material number" id="instruMatFC-{{i}}" (input)="onMaterialNoValueChange($event, i)"  />
          <button *ngIf="insutrumentNumber.control.value" one-icon-button-flat mat-flat-button matSuffix (click)="insutrumentNumber.control.reset(); clearButton('instruMatFC')">
           <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
        <button *ngIf="instrumentMaterialNumber && i === 0" one-icon-button-flat mat-flat-button matSuffix (click)="addInstrumentField()">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#f00"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
        </button>
        <button *ngIf="instrumentMaterialNumber && i !== 0" one-icon-button-flat mat-flat-button matSuffix (click)="removeInstrumentField(i)">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#EA3323"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>
    </div>

    <div *ngIf="showContactsBySafetyAndQuality && contactFC.value === 'safetyAndQuality'" class="inline-controls">

      <mat-form-field>
        <mat-label>Attribute type</mat-label>
        <mat-select oneSelect [formControl]="attTypFC" appearance="fill" size="big" (valueChange)="onContactAttrTypeValueChange($event)">
          <mat-option value="any">Any</mat-option>
          <mat-option value="qualityNotification">Quality Notification</mat-option>
          <mat-option value="safetyBoardNotification">Safety Board Notification</mat-option>
          <mat-option value="supportNotification">Support Notification</mat-option>
        </mat-select>
      </mat-form-field>
      <button *ngIf="attTypFC.value" one-icon-button-flat mat-flat-button matSuffix (click)="attTypFC.reset()">
        <mat-icon>clear</mat-icon>
      </button>

      <mat-form-field appearance="fill" size="big" oneFormField>
        <mat-label>Attribute value</mat-label>
        <input autofocus matInput [formControl]="attValFC" placeholder="Attribute value" id="attValFC" (input)="onContactAttrValueValueChange($event)" />
        <button *ngIf="attValFC.value" one-icon-button-flat mat-flat-button matSuffix (click)="attValFC.reset(); clearButton('attValFC')">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>

    </div>

    <div *ngIf="(showContactsByInstrument || showContactsBySafetyAndQuality) && contactFC.value">
      <mat-form-field appearance="fill" size="big" oneFormField>
        <mat-label>Contact role</mat-label>
        <input autofocus matInput [formControl]="contRolFC" placeholder="ContactRole" id="contRolFC" (input)="onContactRoleValueChange($event)" />
        <button *ngIf="contRolFC.value" one-icon-button-flat mat-flat-button matSuffix (click)="contRolFC.reset(); clearButton('contRolFC')">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div *ngIf="((!showAccountsByIntrument && showContactsByInstrument) || affAccFC.value === null ) && contactFC.value === 'instrument'">
      <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select oneSelect [formControl]="instrumentStatusFC" appearance="fill" size="big" (valueChange)="onInstrumentStatusChange($event)">
          <mat-option value="none">Any</mat-option>
          <mat-option value="installed">Installed</mat-option>
        </mat-select>
      </mat-form-field>
  
    </div>
  </div>

  <div *ngIf="!mappedData || mappedData.length==0" class="inline-controls">
    <button color="primary" mat-flat-button (click)="request()" [disabled]="!requestEnabled || isDisabled">
      Request
    </button>
  </div>

  <div *ngIf="mappedData && mappedData.length>0" class="inline-controls">
    <button color="primary" mat-flat-button (click)="request()" [disabled]="!requestEnabled">
      Request and merge
    </button>

    <button color="primary" mat-stroked-button (click)="clear()" [disabled]="!requestEnabled">
      Clear
    </button>
  </div>

  <div *ngIf="records !== 'Error occurred'" style="margin-bottom: 5px;">{{records}}</div>

  <div *ngIf="records === 'Error occurred'" style="color: #D0342C;">{{records}}</div>

  <table>
    <thead>
      <tr>
        <th></th>
        <th>Account ID &nbsp; (ERP)</th>
        <th>CRM Account ID</th>
        <th>Account name</th>
        <th>Contact name</th>
        <th>Contact email</th>
        <th>Contact role</th>
        <th>Attributes</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of mappedData" [ngClass]="{'no-email': (!data.erpAccountNo || !data.accountName || !data.contactEmail)}">
        <td>
          <mat-checkbox 
            *ngIf="data.contactEmail && data.erpAccountNo && data.accountName" 
            [checked]="data.checked"
            (change)="onCheckValueChange($event, data)"
          ></mat-checkbox>
        </td>
        <td>{{data?.erpAccountNo}}</td>
        <td>{{data?.crmAccountNo}}</td>
        <td>{{data?.accountName}}</td>
        <td>{{data?.contactName}}</td>
        <td>{{data?.contactEmail}}</td>
        <td>{{data?.contactRole}}</td>
        <td>
          <span 
            style="cursor: pointer;"
            title="quality: {{data?.safetyAndQuality?.qualityNotification}}&#10;safetyBoard: {{data?.safetyAndQuality?.safetyBoardNotification}}&#10;support: {{data?.safetyAndQuality?.supportNotification}}"
          >
            ...
          </span>
        </td>
      </tr>
    </tbody>
  </table>

  <br/>

  <div style="display: flex; justify-content: space-between">
    <button color="primary" mat-flat-button (click)="onDownload()" [disabled]="selectedData.length <= 0">
      Download
    </button>

    <div>
      <button color="primary" mat-flat-button (click)="onImport()" [disabled]="selectedData.length <= 0" style="margin-right: 20px;">
        Import
      </button>
  
      <button color="primary" mat-stroked-button (click)="onCancel()">
        Cancel
      </button>
    </div>
  </div>

</div>